export default {
  endpoints: {
    stitchBackend: "https://api.production.withstitch.com",
  },
  debug: false,
};
